module.exports = __webpack_public_path__ + "03f8391997b5aadc52d729613900f194.svg";